export default __webpack_public_path__ + "static/media/illustrated_steps_arrow_up.172daf54.svg";